import { useNavigate, useParams } from "react-router";

import type { DiscountTypeForQueryParams } from "@/routes/_constants";
import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

type Success = {
	canRender: true;
	hotelID: string;
	type: DiscountTypeForQueryParams;
};

type Failure = {
	canRender: false;
};

type ReturnType = Success | Failure;

export const useConfirmParams = (): ReturnType => {
	const { hotelID, type } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.DISCOUNT.NEW>>();

	const navigate = useNavigate();

	let canRender = true;

	/**
	 * @todo ブランク時の振る舞いを設計
	 */
	if (!hotelID || !type) {
		canRender = false;
		notifyUserEventInfo({
			title: "無効なURLです",
			description: "",
		});
		navigate(PATHS.TOP);

		return {
			canRender,
		};
	}

	return {
		canRender,
		hotelID,
		type: type as DiscountTypeForQueryParams,
	};
};
